var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{attrs:{"show":!!_vm.errorHandlingMessage,"variant":"danger","dismissible":""}},[_vm._v(_vm._s(_vm.errorHandlingMessage))]),_c('FormulateForm',{attrs:{"schema":_vm.formSchema,"data":_vm.formData},on:{"submit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }